import React, {FC} from "react";
import {useMedia} from "../../../../../newShared/hooks/useMedia";
import {useMainTranslation} from "../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {Flex} from "../../../../../newShared/components/Layouts";
import {ReleasePhysicalAssets} from "../../components/Dialogs/ReleaseDialog";
import {useSoftwareAssetsList} from "../../hooks/useSoftwareList";
import AddIcon from "@mui/icons-material/Add";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import {PageTitleAndActions} from "../../../../../newShared/components/pageTitleAndActions";
import {ExportCsvDialog} from "../../../../../newShared/components/csvExportDialog";
import {TSoftwareAsset} from "../../types";
import {GenericTable} from "../../../../../newShared/components/genericTable";
import {ImportCsvDialog} from "../../../../../newShared/components/csvImportDialog";
import {useImportCsvSoftware} from "../../hooks/dialogs/useImportCsvSoftware";


export const SoftwareAssetsList:FC = () => {
    const {isLessThen1050} = useMedia();
    const {t, revDir} = useMainTranslation('', {keyPrefix: 'pathPhysicalAssets'});

    const {
        softwareAssets,
        // settings,
        // filter,
        // setSearch,
        // isShowingNoAssets,
        goToAsset,
        goToAddAsset,
        goToSettings,
        exportCsv,
        handleImportCSV,
        handleOpenExportCsv,
        isLoadingList,
        isLoadingExport,
        isLoadingFields,
        // isLoadingSettings,
        handleOpenRelease,

        // pagination: {
        //     bottomLoader,
        //     onScroll,
        //     scrollRef
        // },

        genericTable
    } = useSoftwareAssetsList();

    const importCsv = useImportCsvSoftware();

    return (
        <Flex w={'100%'} h={'100%'} direction={'column'} >
            <PageTitleAndActions
                title={t('Software')}
                showMenuWhen={isLessThen1050}
                actions={[
                    {
                        title: t('Add'),
                        onClick: goToAddAsset,
                        variant: 'text',
                        icon: <AddIcon />,
                        disabled: isLoadingList || isLoadingExport,
                        size: 'small'
                    },
                    {
                        title: t('Settings'),
                        onClick: goToSettings,
                        // variant: 'text',
                        disabled: isLoadingList || isLoadingExport,
                        size: 'small'
                    },
                    {
                        title: t('Release'),
                        onClick: handleOpenRelease,
                        disabled: isLoadingList || isLoadingExport,
                        color: 'secondary',
                        size: 'small'
                    },
                    {
                        title: t('Export CSV'),
                        onClick: handleOpenExportCsv,
                        variant: 'text',
                        icon: <FileDownloadIcon style={{marginLeft: revDir ? '9px' : undefined }}/>,
                        loading: isLoadingExport,
                        disabled: isLoadingExport || isLoadingList,
                        size: 'small'
                    },
                    {
                        title: t('Import CSV'),
                        icon: <FileUploadIcon style={{marginLeft: revDir ? '9px' : undefined }}/>,
                        onClick: handleImportCSV,
                        variant: 'text',
                        disabled: isLoadingList || isLoadingExport,
                        size: 'small'
                    },
                ]}
            />

            <GenericTable<TSoftwareAsset>
                id={'SoftwareAssetsList'}
                columnsConfig={{totalName: 'Total assets', disableColumnsSettings: true, disableShowCards: true}}
                paging={genericTable.paging}
                rowsConfig={{
                    rows: softwareAssets,
                    // customCellPaddings: '8px',
                    getRowUniqueId: (row) => row.id,
                    onRowClick: goToAsset,
                    columnsConfigs: [{key: "name", name: t('Name'), default: true}],
                }}
                filtersConfig={{
                    searchCustomFilterKeyName: 'nameLike',
                    searchAsArray: true,
                    dontSendSearchIfEmpty: true,
                    genericFilterProps: {
                        configs: [],
                        fetchResultWithSelectedFilters: () => null,
                        isAddFilters: false
                    }
                }}
                emptyArrayImageProps={{type: 'physicalAssets', filterNotApplied: {secondaryText: t('You have not added any asset yet.'), text: t('Create asset')}}}
            />

            {/*<Flex w={'100%'} m={'20px 0 0 0'} ai={'center'}>*/}
            {/*    <SearchField*/}
            {/*        size={'small'}*/}
            {/*        sx={{margin: revDir ? '0 0 0 10px' : '0 10px 0 0', width: '320px'}}*/}
            {/*        variant={'outlined'}*/}
            {/*        placeholder={t('Search')}*/}
            {/*        onChange={(e) => {setSearch(e.currentTarget.value)}}*/}
            {/*        value={filter.filter.nameLike}*/}
            {/*        disabled={isLoadingList}*/}
            {/*        onClear={filter.handleCleanSearch}*/}
            {/*        onKeyDown={filter.handleEnterKey}*/}
            {/*    />*/}

            {/*</Flex>*/}

            {/*<TableContainer onScroll={onScroll} ref={scrollRef} sx={{overflowY: isShowingNoAssets ? 'hidden' : undefined}}>*/}
            {/*    <Table stickyHeader >*/}
            {/*        <TableHead>*/}
            {/*            <TableRow >*/}
            {/*                <TableCell align={revDir ? 'right' : 'left'}> {t('Name')}</TableCell>*/}
            {/*                /!*<TableCell align={revDir ? 'right' : 'left'}> {t('Version')}</TableCell>*!/*/}
            {/*            </TableRow>*/}
            {/*        </TableHead>*/}

            {/*        {(!isShowingNoAssets) &&*/}
            {/*            <TableBody>*/}
            {/*                {softwareAssets.map((a) => a && (*/}
            {/*                    <TableRow*/}
            {/*                        hover*/}
            {/*                        key={a?.id}*/}
            {/*                        onClick={() => {goToAsset(a)}}*/}
            {/*                    >*/}
            {/*                        <TableCell align={revDir ? 'right' : 'left'}  >{a.name}</TableCell>*/}
            {/*                        /!*<TableCell align={revDir ? 'right' : 'left'}>{a.version}</TableCell>*!/*/}
            {/*                    </TableRow>*/}
            {/*                ))}*/}
            {/*                {(bottomLoader || isLoadingList) && <TableRowSkeleton columns={1} />}*/}
            {/*            </TableBody>*/}
            {/*        }*/}

            {/*    </Table>*/}
            {/*</TableContainer>*/}

            {/*{filter.filter.prevSearch && !isLoadingList && !softwareAssets.length &&*/}
            {/*    <Typography color={colors.darkBlueText}>{t('Nothing was found for your query. Try changing the query.')}</Typography>}*/}

            {/*<EmptyArrayImage*/}
            {/*    type={'physicalAssets'}*/}
            {/*    isShowing={isShowingNoAssets}*/}
            {/*    withoutAdd*/}
            {/*    text={t('Create asset')}*/}
            {/*    secondaryText={t('You have not added any asset yet.')}*/}
            {/*/>*/}


            {/*DIALOGS*/}
            <ExportCsvDialog
                isOpen={exportCsv.isOpen}
                isLoadingFields={isLoadingFields}
                isLoadingExport={isLoadingExport}
                availableFields={exportCsv.availableFields}
                handleExportCsv={exportCsv.handleExportCsv}
                handleClose={exportCsv.handleClose}
                fieldsMapperKey={"assets"}
            />

            <ReleasePhysicalAssets />

            <ImportCsvDialog
                isOpen={importCsv.isOpen}
                fields={importCsv.fields}
                response={importCsv.response}
                setImportDialog={importCsv.setImportDialog}

                isGettingFields={importCsv.isGettingFields}
                isPerformingCsv={importCsv.isPerformingCsv}
                isLoadingTemplate={importCsv.isLoadingTemplate}

                getFields={importCsv.getFields}
                performCsv={importCsv.performCsv}
                downloadTemplate={importCsv.downloadTemplate}
                fieldsMapperKey={importCsv.fieldsMapperKey}

                fileLimitInMB={5}
            />

        </Flex>
    )

}
